import React from "react";
import Invoice from "../components/Invoice";

const InvoicePage = () => {
  return <Invoice />;
};

export default InvoicePage;
